import AVALIACAO_STATUS from '../../../enums/AVALIACAO_STATUS';

export const wOtpGestorAcessoTamanho = 6;
export const wOtpGestorCooldownMs = 5 * 60 * 1000;

export const wOtpGestorEtapas = {
  solicitar: 'solicitar',
  verificar: 'verificar'
};

export const wOtpGestorModos = {
  idle: 'idle',
  emitindo: 'emitindo',
  validando: 'validando'
};

export const wFluxoEntradaAvaliacao = {
  gate: 'gate',
  questionario: 'questionario',
  entregue: 'entregue',
  encerrada: 'encerrada'
};

export const wFluxoEntradaStatusEntregue = new Set([
  AVALIACAO_STATUS.RESPOSTA_FINALIZADA.id,
  AVALIACAO_STATUS.REVISAO_INICIADA.id,
  AVALIACAO_STATUS.REVISAO_FINALIZADA.id,
  AVALIACAO_STATUS.PROCESSANDO.id,
  AVALIACAO_STATUS.CONCLUIDA.id,
  AVALIACAO_STATUS.ERRO.id,
  AVALIACAO_STATUS.ERRO_PROCESSAMENTO.id
]);

export const wFluxoEntradaStatusEncerrada = new Set([
  AVALIACAO_STATUS.RECUSADA.id,
  AVALIACAO_STATUS.CANCELADA.id
]);
